import React, { useState } from 'react';
import {Button} from "react-bootstrap";
import Swal from 'sweetalert2'; 
import { useTranslation } from 'react-i18next';
import HeaderTop from '@ms/shared/components/frame/header';
import { Card } from 'primereact/card';
import { useParams } from 'react-router-dom';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import { Divider } from 'primereact/divider';
import { apiRedeemResetPasswordToken } from '@ms/shared/services/api/auth';

function AuthRedeemResetPasswordTokenFrm() {
    const { t } = useTranslation();
    const { token } = useParams();
    const [state, setState] = useState({
        token: token,
        is_token_valid: true,
        user: null,
        password: '',
        password_re: '',
    });

    const elementGroupClassName = "flex flex-column gap-2 mb-2";
    const myChangeHandler = (event) => {
        let nam = event.target.name;
        let val = event.target.value;
        setState({ ...state, [nam]: val });
    };

    const activeChangePassword = async () => {
        if (state.password.length < 8) {
            Swal.fire({
                icon: 'error',
                text: t('auth.redeemReset.errors.passwordMinLength'),
            });
            return;
        }

        if (state.password !== state.password_re) {
            Swal.fire({
                icon: 'error',
                text: t('auth.redeemReset.errors.passwordMismatch'),
            });
            return;
        }

        try {
            const res = await apiRedeemResetPasswordToken(state.token, state.password);
            if(res.status === 200) {
                await Swal.fire({
                    icon: 'success',
                    text: t('auth.redeemReset.errors.success'),
                });
                window.location.replace('/login');
            } else {
                setState({ ...state, is_token_valid: false});
            }
          
        } catch (e) {
            console.log('e', e);
            await Swal.fire({
                icon: 'error',
                text: t('auth.redeemReset.errors.failed'),
            });
        }
    };

    return (
        <>
            <HeaderTop activeMenu={"login"}></HeaderTop>
            {state.is_token_valid !== null && (
            <Card className="p-shadow-4">
                <div className="p-fluid ">
                    <h4 className="p-3 text-center text-secondary">{t('auth.redeemReset.title')}</h4>
                    <Divider />
                    <div className="p-fieldset ">  
                    {state.is_token_valid === true ? (
                        <div className="offset-md-2 col-md-8 offset-lg-3 col-lg-6 mt-3">
                            <div className={elementGroupClassName}>
                                <label htmlFor="userName">{t('auth.redeemReset.username')}</label>
                                <InputText
                                    id="userName"
                                    type="text"
                                    readOnly
                                    value={state.user}
                                />
                            </div>
                            <div className={elementGroupClassName}>
                                <label htmlFor="password">{t('auth.redeemReset.password')}</label>
                                <InputText
                                    id="password"
                                    type="password"
                                    name="password"
                                    onChange={myChangeHandler}
                                />
                                <Message
                                    severity="success"
                                    icon
                                    text={t('auth.redeemReset.passwordHint')}
                                />
                            </div>
                            <div className={elementGroupClassName}>
                                <label htmlFor="passwordRe">{t('auth.redeemReset.confirmPassword')}</label>
                                <InputText
                                    id="passwordRe"
                                    type="password"
                                    name="password_re"
                                    onChange={myChangeHandler}
                                />
                            </div>
                            <div className="flex justify-content-center p-4">
                                <Button  variant="secondary" type="button"  className="btn-register-submit"  onClick={activeChangePassword} >
                                    {t('auth.redeemReset.submit')}
                                </Button>
                            </div>
                        </div>
                    ) : ( 
                        <Message
                        severity="secondary"
                        text={t('auth.redeemReset.linkExpired')}
                        style={{ textAlign: 'center', backgroundColor: '#e8e8e8', border: '1px solid #d3d3d3', padding: '10px', borderRadius: '4px' }}
                    /> 
                    )}
                    </div>
                </div>
            </Card>
              )}
        </>
    );
}

export default AuthRedeemResetPasswordTokenFrm;
